import React from "react";
import LoginLayout from "../../layouts/LoginLayout/LoginLayout";
import mockup from '../../assets/Images/Dashboard.png';
import LoginContent from "components/Login/LoginContent";

const LoginPage = () => {
  return <LoginLayout image={mockup} content={<LoginContent />} />;
};
export default LoginPage;
